<template>
  <svg :style="style" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g id="&#229;&#175;&#188;&#232;&#136;&#170;&#230;&#160;&#143;/&#229;&#155;&#190;&#230;&#160;&#135;" clip-path="url(#clip0_3323_73591)">
<path id="Vector 39" d="M21 12H19M3 12L9.5 6.5M3 12L9.5 17.5M3 12H15.5" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</g>
<defs>
<clipPath id="clip0_3323_73591">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
</template>

<script>
export default {
  name: 'back',
  props: {
    fontSize: {
      type: String,
      default: '24px'
    }
  },
  data() {
    return {
      style: {
        width: '1em',
        height: '1em',
        'vertical-align': 'middle',
        fill: 'currentColor',
        overflow: 'hidden',
        'font-size': this.fontSize
      }
    }
  }
}
</script>